export class ConfirmeCodigoCommand {
    email: string = null;
    codigoVerificadorEmail: string = null;
    
    constructor(values: Partial<ConfirmeCodigoCommand> = { }) {

    Object.assign(this, values)
    }
}
    